import { TypeMapping } from "../types/api/Feed";

const nameMapping: { [key: string]: string } = {
  PHOTO: "Photo",
  VIDEO: "Video",
  CAROUSEL: "Carousel",
  STORIES: "Stories",
  REEL: "Reel, Short, etc.",
  "STORY-PHOTO": "Story",
  "STORY-VIDEO": "Story",
};

export function getValidTypes(postTypes: string[], typeMapping?: TypeMapping) {
  if (!typeMapping) {
    return postTypes?.map((t) => ({
      type: t,
      name: nameMapping[t],
    }));
  }

  const validTypes = postTypes?.filter((t) => typeMapping[t]?.type === t);

  return validTypes.map((t) => ({
    type: typeMapping[t]?.type ?? t,
    name: typeMapping[t]?.name ?? nameMapping[t],
  }));
}
